<h2 class="dialog-fail_title" mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{'alert.notification' | translate}}
    <button type="button" class="close v2-btn-close dialog-fail_close-btn" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
</h2>
<div style="padding: 0 24px;">
  <mat-divider inset="true"></mat-divider>
</div>
<div class="wrap-popup">
  <div class="row">
    <div class="col-2 pr-0" style="text-align: center; padding-top: 15px;">
      <!--<em class="material-icons confirm-ico">
        info
      </em>-->
      <em class="fa fa-warning large v2-color-deny"></em>
    </div>
    <div class="col-10 pr-0">
      <div [innerHTML]="message | translate" style=" padding: 5px 7px 0; font-size: medium; overflow-wrap: break-word; font-weight: 600"></div>
      <p style="padding: 0 7px 0; font-size: medium; overflow-wrap: break-word; font-weight: 600">Chú ý: Lượt EKYC sẽ bị trừ vào lượt của người lập hợp đồng.</p>
    </div>
  </div>
  
  
  <div mat-dialog-actions class="justify-content-center">
  
    <!--build icon, set default cancel-->
    <button class="v2-btn-cancel v2-font-semi" mat-stroked-button color="primary" type="button" (click)="onNoClick()" cdkFocusInitial>
      <mat-icon class="mr-2">cancel</mat-icon>{{'button.cancel' | translate}}
    </button>
    <button class="ml-4 v2-btn-accept v2-font-semi" mat-raised-button [mat-dialog-close]="true">
      <mat-icon class="mr-2">done</mat-icon>{{'button.re_sign' | translate}}
    </button>
  </div>
</div>
  
